export const isMobile: boolean = /Mobi|Android/i.test(navigator.userAgent);
